function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "schedule icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 14.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "schedule icon",
    d: "M2.666 4.007a1.988 1.988 0 0 1-1.415-.586L.222 2.506a.667.667 0 0 1 .888-1l1.057.943a.667.667 0 0 0 .971.027L5.54.192a.667.667 0 0 1 .919.965L4.066 3.433a1.976 1.976 0 0 1-1.4.574zM16 2.674a.667.667 0 0 0-.667-.667H8.666a.667.667 0 0 0 0 1.333h6.666A.667.667 0 0 0 16 2.674zM4.066 8.766 6.459 6.49a.667.667 0 1 0-.919-.965l-2.4 2.287a.682.682 0 0 1-.943 0L1.138 6.755a.667.667 0 1 0-.943.945l1.057 1.055a2 2 0 0 0 2.817.011zM16 8.007a.667.667 0 0 0-.667-.667H8.666a.667.667 0 0 0 0 1.333h6.666A.667.667 0 0 0 16 8.007zM4.066 14.1l2.39-2.276a.667.667 0 1 0-.919-.965l-2.4 2.287a.667.667 0 0 1-.971-.027l-1.056-.943a.667.667 0 0 0-.888 1l1.029.916a2 2 0 0 0 2.817.011zM16 13.341a.667.667 0 0 0-.667-.667H8.666a.667.667 0 0 0 0 1.333h6.666a.667.667 0 0 0 .668-.666z",
    transform: "translate(.001 -.023)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedScheduleIcon);
export default __webpack_public_path__ + "static/media/detailed-schedule-icon.e25188d4600287e3990f975b77e7736d.svg";
export { ForwardRef as ReactComponent };